import { Component, inject, ViewEncapsulation } from '@angular/core';
import { MotifProgressLoaderModule } from '@ey-xd/ng-motif';
import { CommonService } from '@services/common.service';

@Component({
    selector: 'app-data-loader',
    imports: [MotifProgressLoaderModule],
    templateUrl: './data-loader.component.html',
    styleUrl: './data-loader.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class DataLoaderComponent {
  commonService = inject(CommonService);
  isLoading = this.commonService.isLoading;
}
